import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Button } from '../../../../components/Button/Button';
import { Modal, ModalRef } from '../../../../components/Modal/Modal';
import { useLanguage } from '../../../../locale/useLanguage';

type WeightWarningModalProps = {
  onContinue?: () => void;
};

export const WeightWarningModal: React.ForwardRefExoticComponent<
  WeightWarningModalProps & React.RefAttributes<ModalRef>
> = forwardRef(({ onContinue }, forwardedRef) => {
  const [t] = useLanguage();
  const modalRef = useRef<ModalRef>(null);

  useImperativeHandle(forwardedRef, () => ({
    openModal: modalRef.current!.openModal,
    closeModal: modalRef.current!.closeModal,
  }));

  return (
    <Modal ref={modalRef} hasClose>
      <h3 className="modal-title">{t('weightWarningModal.title')}</h3>
      <p className="modal-description">{t('weightWarningModal.description')}</p>
      <div className="modal-button-container">
        <Button
          onClick={onContinue}
          label={t('weightWarningModal.confirm')}
          isPrimary
        />
      </div>
    </Modal>
  );
});
